import request from '../_helpers/request';
import axios from 'axios'

export const empLayoutService = {
    GetEMPHeader
    ,GetEMPFooter
};

function GetEMPHeader() {
    var lang = localStorage.getItem("currentLang");
    var url = "https://www.chinaplasonline.com/eMarketplace/HeaderOnly/" + lang;

    return axios({
        method: 'get',
        url: url,
        withCredentials: false
      }).then(res => {
        return res;
      });

}

function GetEMPFooter() {
    var lang = localStorage.getItem("currentLang");
    var url = "https://www.chinaplasonline.com/eMarketplace/FooterOnly/" + lang;

    return axios({
        method: 'get',
        url: url,
        withCredentials: false
      }).then(res => {
        return res;
      });

}